import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './reduxStore';
import './index.scss';
import DataProvider from './contexts/dataContext';
import {ScrollToTop} from "./hooks/useScrollToTop";
import * as Sentry from "@sentry/react";
import type { Integration } from "@sentry/core";
import moment from "moment-timezone";
// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'; // TODO: re-enable when BE reCaptcha is ready

const root = ReactDOM.createRoot(
    document.getElementById('twentyfourrent-rrm') as HTMLElement
);

let shortcodeLang;
let shortcodeCity;
let shortcodeMap;

// Session Replay continuously records DOM mutations — a measurable main-thread cost on
// mobile CPUs, where INP already fails site-wide (Search Console 8/2026). Microsoft
// Clarity still records mobile sessions, so keep Sentry Replay desktop-only.
const smallScreen = window.matchMedia('(max-width: 767px)').matches;

const sentryIntegrations: Integration[] = [
    Sentry.browserTracingIntegration({enableInp: true}),
];
if (!smallScreen) {
    sentryIntegrations.push(
        Sentry.replayIntegration({
            maskAllText: false,
            maskAllInputs: true,
            mask: ['.sentry-mask', '[data-sentry-mask]'],
            networkRequestHeaders: ["Cache-Control"],
            networkResponseHeaders: ["Referrer-Policy"]
        }),
    );
}

Sentry.setUser({username: window.location.host}); // can add own temp username here if monitoring on Sentry
Sentry.init({
    dsn: 'https://16fdf705703a95de8fcf871151f16d0a@o1120901.ingest.us.sentry.io/4507260438183936',
    // this assumes your build process replaces `process.env.npm_package_version` with a value
    integrations: sentryIntegrations,

    tracesSampleRate: 1.0,
    replaysSessionSampleRate: smallScreen ? 0 : 0.1,
    replaysOnErrorSampleRate: smallScreen ? 0 : 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [ /^https:\/\/dev-rent\.24rent\.fi/,  /^https:\/\/rent\.24rent\.fi/,  /^https:\/\/www\.24rent\.fi/,  /^https:\/\/dev-frontend\.24rent\.fi/],
});

moment.tz.setDefault('Europe/Helsinki');

// checks environment to avoid run error
// the global wp params will only be available in a shortcode compatible environment (like word press sites)
if ((window as any).shortcode_parameters) {
    shortcodeLang = (window as any).shortcode_parameters.lang;
    shortcodeCity = (window as any).shortcode_parameters.city;
    shortcodeMap = (window as any).shortcode_parameters.map;
}

sessionStorage.removeItem('starsUpdatedDS'); // remove if exists
sessionStorage.removeItem('acrissCodesUpdatedDS'); // remove if exists

root.render(
    // {/* TODO: re-enable GoogleReCaptchaProvider when BE reCaptcha is ready */}
    // <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? ''}>
        <Provider store={store}>
            <DataProvider>
                <BrowserRouter>
                    <ScrollToTop >
                        <App shortcodeLang={shortcodeLang} shortcodeCity={shortcodeCity}
                             shortcodeMap={shortcodeMap}/>
                    </ScrollToTop>
                </BrowserRouter>
            </DataProvider>
        </Provider>
    // </GoogleReCaptchaProvider>
);
